import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
const ServicesPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const navigate = useNavigate();
  const filteredServices = services.filter(service => (selectedCategory === 'all' || service.category === selectedCategory) && service.name.toLowerCase().includes(searchTerm.toLowerCase()));
  const handleServiceSelect = (serviceId: number) => {
    // In a real app, you would store the selected service in state/context
    // For this prototype, we'll just navigate to the booking page
    navigate('/booking');
  };
  return <div className="container mx-auto px-4 py-8" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <h1 className="text-3xl font-bold mb-8 text-center" data-id="element-183">Our Services</h1>
        {/* Search and filter */}
        <div className="mb-8" data-id="element-184">
          <div className="relative mb-4" data-id="element-185">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-186">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-187" />
            </div>
            <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search services..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-188" />
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-189">
            <button onClick={() => setSelectedCategory('all')} className={`px-4 py-2 rounded-full text-sm font-medium ${selectedCategory === 'all' ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-190">
              All Services
            </button>
            {categories.map(category => <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`px-4 py-2 rounded-full text-sm font-medium ${selectedCategory === category.id ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-191">
                {category.name}
              </button>)}
          </div>
        </div>
        {/* Services list */}
        <div className="space-y-6" data-id="element-192">
          {filteredServices.map(service => <div key={service.id} className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-193">
              <div className="flex flex-col md:flex-row" data-id="element-194">
                <div className="md:w-1/4" data-id="element-195">
                  <img src={service.image} alt={service.name} className="w-full h-48 md:h-full object-cover" data-id="element-196" />
                </div>
                <div className="p-6 md:w-3/4" data-id="element-197">
                  <h2 className="text-xl font-semibold mb-2" data-id="element-198">{service.name}</h2>
                  <p className="text-gray-600 mb-4" data-id="element-199">{service.description}</p>
                  <div className="flex flex-wrap items-center justify-between" data-id="element-200">
                    <div data-id="element-201">
                      <p className="text-teal-600 font-semibold" data-id="element-202">
                        From £{service.price}
                      </p>
                      <p className="text-gray-500 text-sm" data-id="element-203">
                        {service.duration} mins
                      </p>
                    </div>
                    <button onClick={() => handleServiceSelect(service.id)} className="mt-4 md:mt-0 bg-teal-600 text-white py-2 px-6 rounded-md hover:bg-teal-700 transition-colors" data-id="element-204">
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </div>)}
          {filteredServices.length === 0 && <div className="text-center py-10" data-id="element-205">
              <p className="text-gray-600" data-id="element-206">
                No services found matching your criteria.
              </p>
            </div>}
        </div>
      </div>
    </div>;
};
// Sample data
const categories = [{
  id: 'nails',
  name: 'Nails'
}, {
  id: 'massage',
  name: 'Massage'
}, {
  id: 'facial',
  name: 'Facial'
}, {
  id: 'hair',
  name: 'Hair'
}];
const services = [{
  id: 1,
  name: 'Classic Manicure',
  description: 'Our classic manicure includes nail shaping, cuticle care, hand massage, and polish application.',
  price: 35,
  duration: 45,
  category: 'nails',
  image: 'https://images.unsplash.com/photo-1610992015732-2449b76344bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  name: 'Gel Manicure',
  description: 'Long-lasting gel polish that dries instantly and stays shiny for up to two weeks.',
  price: 45,
  duration: 60,
  category: 'nails',
  image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 3,
  name: 'Swedish Massage',
  description: 'A gentle full body massage designed to improve circulation, ease tension and promote relaxation.',
  price: 65,
  duration: 60,
  category: 'massage',
  image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 4,
  name: 'Deep Tissue Massage',
  description: 'Targets the deeper layers of muscle and connective tissue to release chronic patterns of tension.',
  price: 75,
  duration: 60,
  category: 'massage',
  image: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 5,
  name: 'Hydrating Facial',
  description: 'Deeply moisturizing treatment that replenishes dry skin and restores a healthy glow.',
  price: 55,
  duration: 60,
  category: 'facial',
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 6,
  name: 'Anti-Aging Facial',
  description: 'Targeted treatment to reduce fine lines and wrinkles, improve skin texture and boost collagen production.',
  price: 75,
  duration: 75,
  category: 'facial',
  image: 'https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 7,
  name: 'Blow Dry & Styling',
  description: 'Professional blow dry and styling to give your hair volume, shine and the perfect finish.',
  price: 40,
  duration: 45,
  category: 'hair',
  image: 'https://images.unsplash.com/photo-1560869713-7d0a29430803?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export default ServicesPage;